const Section = ({ title, children }) => (
  <div className="mb-6 text-gray-800">
    <div className="bg-gray-100 px-4 py-2 font-semibold border">{title}</div>
    <div className="border border-t-0 p-4 bg-white">{children}</div>
  </div>
);

export default Section;
